import React from 'react';
import { Link } from 'react-router-dom'; // to change path from inside or to alter react-router-dom path
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import Error from 'components/ErrorMessage';// to display error messages on invalid user input
import styles from './Password.scss';// to import local scss fle

const Password = (props) => {
  const handleOnChange = (e) => {
    props.onChange(e);
  };
  const renderForgotPassword = renderIf(props.addForgotPassword);
  const renderError = renderIf(props.errorMessage);
  return (
    <div className={props.errorMessage === '' ? cn('row', styles.passwordContainer) : cn('row', styles.passwordContainerOnError)}>
      <div className={cn('col s12', styles.labelsContainer)}>
        <label className={styles.label} htmlFor="PASSWORD">PASSWORD</label>
        {renderForgotPassword(
          <Link to="/forgot" tabIndex="-1" >
            <label tabIndex="-1" htmlFor="FORGOT PASSWORD?" className={styles.forgotPassword}>Forgot Password?</label>
          </Link>,
          )}
      </div>
      <Input
        className={cn('col s12', styles.input)}
        type="Password"
        onChange={handleOnChange}
        onKeyPress={props.onKeyPress}
        onFocus={props.onFocus}
      />
      {renderError(
        <Error message={props.errorMessage} />,
        )}
    </div>);
};

Password.propTypes = {
  onChange: PropTypes.func.isRequired,
  addForgotPassword: PropTypes.isRequired,
  errorMessage: PropTypes.string.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
};

Password.defaultProps = {
  onChange: () => {},
  addForgotPassword: true,
  errorMessage: '',
  onFocus: () => {},
};


export default Password;



// WEBPACK FOOTER //
// ./src/components/Password/Password.js